<template>
<div>
  <about-title page-route="/sub/light-blocks/news/certificates" title="گواهینامه ها"></about-title>
  <v-container>
    <v-row>
      <v-col v-for="(item,i) in galleryItem.slice(0,2)" :key="i" cols="6">
<div @click="dialogBox(item)" class="w-60 g-box  mb-10 ma-auto">
  <v-img class="mb-3" style="position: relative" :src="item.file">
    <div class="date-box" >
      <span>{{item.date}}</span>
      <span class="d-flex align-center justify-center">
        {{item.views}}
        <v-icon class="mr-2" small color="white">mdi-eye</v-icon>
      </span>
    </div>
  </v-img>
  <h5 class="font-weight-bold">{{item.title}}</h5>
</div>
      </v-col>
    </v-row>
  </v-container>
  <div class="d-flex flex-column justify-center align-center">
    <v-dialog  width="900" class="d-flex justify-center align-center text-center"  v-model="showImageDialog">
      <v-card  width="900" height="100%">
        <v-app-bar>
          <v-icon @click="showImageDialog=false">mdi-close</v-icon>
        </v-app-bar>
            <img alt="image" style="object-fit: fill" width="900" height="500" :src="showImage"/>

      </v-card>
    </v-dialog>
    <div @click="$router.push({name:'baseCertificates'})" class="skew px-8 py-3 pointer success white--text">بیشتر</div>
  </div>
</div>
</template>

<script>
import AboutTitle from "../../../About/Components/AboutTitle";
export default {
  name: "certificates",
  components:{AboutTitle},
props:{
  galleryItem:Array
},
  data(){
    return{
      showImage:'',
      showImageDialog:false,
      galleryItem:[
        {
          id:1,
          title:'اردکان',
          file:require('../../../../../../../assets/images/news-images/4.jpg'),
          date:'۲۰۱۸-۳-۴',
          views:2
        },
        {
          id:2,
          title:'اردکان',
          file:require('../../../../../../../assets/images/news-images/4.jpg'),
          date:'۲۰۱۸-۳-۴',
          views:2
        },
        {
          id:3,
          title:'اردکان',
          file:require('../../../../../../../assets/images/news-images/4.jpg'),
          date:'۲۰۱۸-۳-۴',
          views:2
        },
        {
          id:4,
          title:'اردکان',
          file:require('../../../../../../../assets/images/news-images/4.jpg'),
          date:'۲۰۱۸-۳-۴',
          views:2
        },

      ]
    }
  },
  methods:{
    dialogBox(item){
      this.showImageDialog=true;
      this.showImage=item.file;

    }
  }
}
</script>

<style scoped>
.date-box{
  padding: 0 10px;
  text-align: center;
  position: absolute;
  bottom: 0;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.6);
}
.g-box:hover>*>*>.date-box{
  background-color: #0846be;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}
.date-box>*{
  color: white;
  font-size: 16px !important;
}
.skew:hover{
  background-color: #0846be !important;
}
</style>